export default "__VITE_ASSET__BG9FRRw9__"